import _ from "lodash";
import { useEffect, useState } from "react";

export const POST_IMAGE_SIZES = {
  small: "sm_webp",
  medium: "md_webp",
  large: "lg_webp",
};

export const getRelationItem = (item, name) => {
  const value = item[name].data;
  if (_.isArray(value)) {
    return value.map((i) => ({
      id: i.id,
      ...i.attributes,
    }));
  } else {
    return {
      id: item[name].data?.id,
      ...item[name].data?.attributes,
    };
  }
};

export const getPostImageUrl = (post, size) => {
  const image = getRelationItem(post, "mainImage");

  let url = image.url;
  if (size) {
    const newURL = image.formats?.[size]?.url;
    if (newURL) {
      url = newURL;
    }
  }
  return url;
};

// Everything an <img> of a post's main image needs besides styling: the `size` format as the
// fallback src, a srcset over Strapi's webp formats so the browser can pick a smaller file, the
// original's intrinsic dimensions (they give the box its aspect ratio before the file arrives),
// and the post title as alt text. `sizes` describes the rendered width of the slot.
export const getPostImageProps = (post, size, sizes) => {
  const image = getRelationItem(post, "mainImage");
  const srcSet = Object.values(POST_IMAGE_SIZES)
    .map((name) => image.formats?.[name])
    .filter((format) => format?.url && format?.width)
    .map((format) => `${format.url} ${format.width}w`)
    .join(", ");

  return {
    src: getPostImageUrl(post, size),
    ...(srcSet && { srcSet, sizes }),
    ...(image.width && image.height && { width: image.width, height: image.height }),
    alt: post.title || "",
  };
};

export const getPostLink = (post) => {
  return `/news/${post.id}`;
};

export const useMediaQuery = (query) => {
  const [matches, setMatches] = useState(false);

  useEffect(() => {
    const media = window.matchMedia(query);
    if (media.matches !== matches) {
      setMatches(media.matches);
    }

    const listener = () => setMatches(media.matches);
    media.addEventListener("change", listener);

    return () => media.removeEventListener("change", listener);
  }, [matches, query]);

  return matches;
};
